import styled from 'styled-components';
import { white } from 'constants/theme';

export const SocialCss = styled.nav`
  margin-top: 40px;
  height: 60px;
  a {
    display: inline-block;
    text-decoration: none;
    padding: 0rem 2px;

    &:hover {
      color: inherit;
    }
    div {
      color: inherit;
      font-size: 36px !important;
      font-family: 'simple-line-icons';
      color: white;
    }
  }
  .social-logo {
    color: ${white};
    height: 35px;
  }
`;
